export default function newError(cause) {
    var errorContent = parse(cause);
    var e = typeof errorContent === "object" ? errorContent : new Error(errorContent);
    if (typeof errorContent === "string") {
        e.cause = cause;
    }
    return e;
};
function parse(cause) {
    var error = cause.error, errorCode = cause.errorCode, message = cause.message, errorMessage = cause.errorMessage;
    if (error || errorCode) {
        return error || errorCode;
    } else if (message || errorMessage) {
        return message || errorMessage;
    } else {
        return "";
    }
}
